import { createCachedAPI } from '../utils/api';

export interface DayMatches {
  /** Formatted as 2026-08-04 */
  date: string;
  matches: number;
}

export interface WeekMatches {
  /** Formatted as 2026-07-31 */
  startDate: string;
  /** Six days after startDate, formatted as 2026-08-06 */
  endDate: string;
  matches: number;
}

export const getMatchStats = createCachedAPI<{
  incomingCvs: number;
  matches: number;
  matchedCvs: number;
  days: DayMatches[];
  weeks: WeekMatches[];
}>(import.meta.env.VITE_API_MATCHES);
